import { BufferedSourceJsonReader1eguw7qhrwt7p as BufferedSourceJsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/BufferedSourceJsonReader.mjs';
import { readAny17j2jqaxubdko as readAny } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toJsonMap(_this__u8e3s4) {
  var tmp = readAny(new (BufferedSourceJsonReader())(_this__u8e3s4));
  return (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
}
function nodeAtPath(map, path) {
  var node = map;
  var _iterator__ex2g4s = path.p1();
  while (_iterator__ex2g4s.q1()) {
    var key = _iterator__ex2g4s.r1();
    var tmp;
    if (!(node == null) ? isInterface(node, KtList()) : false) {
      var tmp_0 = node;
      tmp = tmp_0.r2(typeof key === 'number' ? key : THROW_CCE());
    } else {
      if (!(!(node == null) ? isInterface(node, KtMap()) : false))
        THROW_CCE();
      // Inline function 'kotlin.collections.get' call
      var this_0 = node;
      tmp = (isInterface(this_0, KtMap()) ? this_0 : THROW_CCE()).u4(key);
    }
    node = tmp;
  }
  return node;
}
function deepMergeObject(destination, obj) {
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = obj.l3().p1();
  while (_iterator__ex2g4s.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.m3();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.n3();
    var tmp;
    if (destination.s4(key)) {
      var tmp_0 = destination.u4(key);
      tmp = !(tmp_0 == null) ? isInterface(tmp_0, KtMutableMap()) : false;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_1 = destination.u4(key);
      var fieldDestination = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap()) : false) ? tmp_1 : THROW_CCE();
      var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtMap()) : false) ? value : null;
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.error' call
        var message = "'" + key + "' is an object in destination but not in map";
        throw IllegalStateException().o(toString(message));
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      var fieldMap = tmp_2;
      deepMergeObject(fieldDestination, fieldMap);
    } else {
      // Inline function 'kotlin.collections.set' call
      destination.x4(key, value);
    }
  }
}
//region block: exports
export {
  deepMergeObject as deepMergeObject115s855ldv6gd,
  nodeAtPath as nodeAtPath1cd3xt81xpfir,
  toJsonMap as toJsonMaprsmqd9lb9sfm,
};
//endregion

//# sourceMappingURL=JsonMap.mjs.map
